import { render, staticRenderFns } from "./MyStore.vue?vue&type=template&id=3c3830c0&scoped=true"
import script from "./MyStore.vue?vue&type=script&lang=js"
export * from "./MyStore.vue?vue&type=script&lang=js"
import style0 from "./MyStore.vue?vue&type=style&index=0&id=3c3830c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3830c0",
  null
  
)

export default component.exports